/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! ()");
/* eslint-enable no-console */
const burgerMenuButton = document.getElementById("burger-menu-button");
const menuButton = document.getElementById("menu-button");
const menuItems = document.getElementById("menu-items");

if (menuButton && menuItems) {
	menuButton.addEventListener("click", function () {
		const isExpanded = menuButton.getAttribute("aria-expanded") === "true";
		menuButton.setAttribute("aria-expanded", !isExpanded);
		menuItems.classList.toggle("hidden");
	});

	// Close the dropdown menu if the user clicks outside of it
	document.addEventListener("click", function (event) {
		if (
			!menuButton.contains(event.target) &&
			!menuItems.contains(event.target)
		) {
			menuButton.setAttribute("aria-expanded", "false");
			menuItems.classList.add("hidden");
		}
	});
} else {
	console.error("Menu button or menu items not found.");
}

if (burgerMenuButton) {
	burgerMenuButton.addEventListener("click", toggleMenu);
}

function toggleMenu() {
	// Handle menu SVG animation
	document.getElementById("burgerMenuSvg").classList.toggle("hidden");
	document.getElementById("burgerMenuCloseSvg").classList.toggle("hidden");

	// Toggle the menu
	document.getElementById("fullscreen-menu").classList.toggle("hidden");
	// const menuImg = document.querySelector(".menu-img");
	// if (menu.classList.contains("hidden")) {
	// 	menu.classList.remove("hidden");
	// 	menuImg.src = "../src/assets/icons/Icons.svg"; // Path to your close icon
	// } else {
	// 	menu.classList.add("hidden");
	// 	menuImg.src = "../src/assets/icons/menu-left-alt.svg"; // Path to your menu icon
	// }
}
